import Cookies from 'universal-cookie';
import ErrorHandler from '~/glm/utils/error-handler';

export default class WeddingApi {
  static cookies = new Cookies();

  static get(path) {
    return WeddingApi.baseFetch(path, {
      method: 'GET',
      headers: WeddingApi.baseHeaders(),
    });
  }

  static getOrCreate(path, data) {
    return WeddingApi.baseFetch(path, {
      method: 'GET',
      headers: WeddingApi.baseHeaders(),
    }).then(responseJSON => {
      if (responseJSON.length) {
        return responseJSON;
      }
      return WeddingApi.post(path, data).then(postJSON => (Array.isArray(postJSON) ? postJSON : [postJSON]));
    });
  }

  static post(path, data) {
    return WeddingApi.baseFetch(path, {
      method: 'POST',
      headers: WeddingApi.baseHeaders(),
      body: JSON.stringify(data),
    });
  }

  static put(path, data) {
    return WeddingApi.baseFetch(path, {
      method: 'PUT',
      headers: WeddingApi.baseHeaders(),
      body: JSON.stringify(data),
    });
  }

  static delete(path) {
    return WeddingApi.baseFetch(path, {
      method: 'DELETE',
      headers: WeddingApi.baseHeaders(),
    });
  }

  static baseFetch(path, init) {
    return fetch(`${process.env.REACT_APP_GLM_WEDDING_API_ENDPOINT}${path}`, init)
      .then(WeddingApi.parseResponse)
      .then(WeddingApi.scrubResponseJSON)
      .catch(response => {
        WeddingApi.handleRejectedFetch(response, path, init);
        return Promise.reject(response);
      });
  }

  static parseResponse(response) {
    if (response && response.ok) {
      if (response.status >= 200 || response.status <= 299) {
        return Promise.resolve(response.json());
      } else {
        return Promise.resolve();
      }
    }

    try {
      return new Promise((_, reject) => {
        response.text().then(text => (text ? reject(JSON.parse(text)) : {}));
      });
    } catch (err) {
      return Promise.reject();
    }
  }

  static scrubResponseJSON(responseJSON) {
    function eachRecursive(obj) {
      Object.keys(obj).forEach(k => {
        if (typeof obj[k] === 'object' && obj[k] !== null) {
          eachRecursive(obj[k]);
        }
      });
    }

    eachRecursive(responseJSON);
    return Promise.resolve(responseJSON);
  }

  static handleRejectedFetch(response, path, init) {
    if (!response || !response.status) {
      WeddingApi.triggerErrorHandler({
        path,
        context: {
          url: path,
          request: init,
        },
      });
    } else if (response.status >= 404) {
      WeddingApi.triggerErrorHandler({
        path,
        context: {
          url: path,
          request: init,
          response: {
            body: response,
            status: response.status,
            statusText: response.statusText,
          },
        },
      });
    }
    return response;
  }

  static triggerErrorHandler({ path, context }) {
    ErrorHandler.notify({
      name: `WeddingApi Error - ${path}`,
      component: 'WeddingApi',
      action: 'baseFetch()',
      context,
      fingerprint: 'GLM',
      triggerHandleErrorCallback: true,
    });
  }

  static baseHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'MEMBERSHIP-SESSION-TOKEN': WeddingApi.getSessionToken(),
      'x-api-key': process.env.REACT_APP_GLM_WEDDING_API_KEY,
    };
  }

  static getSessionToken() {
    if (!WeddingApi.cookies) {
      WeddingApi.cookies = new Cookies();
    }
    return WeddingApi.cookies.get('xo-session-token');
  }
}
